import { render, staticRenderFns } from "./userOrgDialog.vue?vue&type=template&id=06399ea8&scoped=true"
import script from "./userOrgDialog.vue?vue&type=script&lang=js"
export * from "./userOrgDialog.vue?vue&type=script&lang=js"
import style0 from "./userOrgDialog.vue?vue&type=style&index=0&id=06399ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06399ea8",
  null
  
)

export default component.exports